import { User } from "@/@types/responses/user/User"
import { Note } from "../note/Note"
import { AuditableResponse } from "../common/AuditableResponse"
import { PurchaseOrderItemDetails } from "./PurchaseOrderItemDetails"

export class PurchaseOrderDetails extends AuditableResponse {
  id: number
  canAddItems: boolean
  canReceiveAll: boolean
  description: string
  setACalendarDate: string
  poNumber: string
  venderPoNumber: string
  submitted: boolean
  submittedDate?: string
  submittedByUser?: User
  verified: boolean
  verifiedDate?: string
  verifiedByUser?: User
  supplierId?: number
  notes: Note[]
  purchaseOrderItems: PurchaseOrderItemDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, canAddItems?: boolean, canReceiveAll?: boolean, description?: string, setACalendarDate?: string, poNumber?: string, venderPoNumber?: string, submitted?: boolean, submittedDate?: string, submittedByUserJson?: any, verified?: boolean, verifiedDate?: string, verifiedByUserJson?: any, supplierId?: number, notesJson?: any, purchaseOrderItemsJson?: any, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.canAddItems = canAddItems ?? false
    this.canReceiveAll = canReceiveAll ?? false
    this.description = description ?? ''
    this.setACalendarDate = setACalendarDate ?? ''
    this.poNumber = poNumber ?? ''
    this.venderPoNumber = venderPoNumber ?? ''
    this.submitted = submitted ?? false
    this.submittedDate = submittedDate
    this.verified = verified ?? false
    this.verifiedDate = verifiedDate
    this.supplierId = supplierId
    this.submittedByUser = submittedByUserJson ? new User(submittedByUserJson) : undefined
    this.verifiedByUser = verifiedByUserJson ? new User(verifiedByUserJson) : undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notesJson ? notesJson.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.purchaseOrderItems = purchaseOrderItemsJson ? purchaseOrderItemsJson.map((p: any) => new PurchaseOrderItemDetails(p.id, p.canBeUsedToFulfillOrderPart, p.displayOrder, p.name, p.price, p.purchaseOrderItemFor, p.receivedByUser, p.receivedDate)) : []
  }
}
